import { styled } from "@mui/material/styles";

const StyledInfo = styled("div")(
  ({ theme }) => `
 .info-header {
    position: relative;
    background-size: cover;
    background-position: center;
    height: 362px;
    display: flex;
    alignItems: center;
    justify-content: center;
    color: white;
 }

  .info-text {
    position: absolute;
    bottom: 42px;
    left: 87px;
    @media screen and (max-width: 1024px) {
     left: 50px;
     bottom: 35px;
    }
     @media screen and (max-width: 480px) {
     left: 20px;
     bottom: 20px;
    }
  }
 .text-heading {
    font-weight: 400;
    font-size: 48px;
    font-style: normal;
    line-height: 60px;
    color: ${theme.palette.customColor.white};
    font-family: Lexend;
    text-align: left;
    @media screen and (max-width: 1024px) {
     font-size: 35px;
     line-height: 43px;
    }
    @media screen and (max-width: 480px) {
     font-size: 24px;
     line-height: 30px;
    }
}   
.text-body {
  font-weight: 400;
  font-size: 16px;
  font-style: normal;
  line-height: 20px;
  color: ${theme.palette.customColor.white};
  font-family: Lexend;
  text-align: left;
  @media screen and (max-width: 1024px) {
     font-size: 13px;
     line-height: 16px;
    }
  @media screen and (max-width: 480px) {
     font-size: 12px;
     line-height: 15px;
    }
     
     
}   
.tabs {
  padding: 0px 80px;
  @media screen and (max-width: 1024px) {
    padding: 0px 50px;
  }
  @media screen and (max-width: 480px) {
    padding: 0px 17px;
  }
}
`
);

export default StyledInfo;
